import { User } from "oidc-client";
import { useSecurity } from "./useSecurity";
import { isLoggedIn } from "./utils";

interface UseUser {
  user: User;
  loggedIn: boolean,
}
export const useUser = (): UseUser => {
  const { user } = useSecurity();
  const loggedIn = isLoggedIn(user);

  return { user: user!,
    loggedIn,
  };
};